import React from 'react';
import classNames from 'classnames';
import IndexTableBodyCell from 'components/shared/index/table/body_cell';

const STATES = {
  DRAFT: 'draft',
  NEW_VERSION_PENDING: 'new_version_pending',
  PUBLISHED: 'published',
};

const translations = {
  [STATES.DRAFT]: t('drafts.state.draft'),
  [STATES.NEW_VERSION_PENDING]: t('drafts.state.new_version_pending'),
  [STATES.PUBLISHED]: t('drafts.state.published'),
};

const StateCell = ({
  state,
  versionNumber,
  scorm,
  hasVersionsFeature,
  hasScormVersionsFeature,
  className,
  type,
}) => {
  const indicatorClassName = classNames('Pill Pill--dot mr-8', {
    'Pill--outline': state === STATES.NEW_VERSION_PENDING,
    'Pill--tealLighter': state === STATES.DRAFT,
  });
  const hasVersionsFeatureNonDraftState =
    hasVersionsFeature && state !== STATES.DRAFT;

  const showVersionNumber =
    ((!scorm && hasVersionsFeatureNonDraftState) ||
      (scorm && hasScormVersionsFeature)) &&
    versionNumber;

  return (
    <IndexTableBodyCell size="l" name="state" contentClassName="d-b">
      <span className={indicatorClassName} />
      {hasVersionsFeatureNonDraftState &&
      type === 'lesson' &&
      !scorm &&
      !versionNumber ? (
        <span
          className={classNames('fz-base h-c-gray-darker', {
            [className]: className,
          })}
        >
          <button
            type="button"
            className="u-resetBtn o-0"
            data-toggle="tooltip"
            data-original-title={t('versions.published_tool_tip')}
          >
            {translations[state]}
          </button>
        </span>
      ) : (
        <span
          className={classNames('fz-base hyphens-none', {
            [className]: className,
          })}
        >
          {translations[state]}
        </span>
      )}

      {showVersionNumber && (
        <div className="StatusColumnVersionNumber">
          {t('versions.version_with_number', {
            version_number: versionNumber,
          })}
        </div>
      )}
    </IndexTableBodyCell>
  );
};

export default StateCell;
